const firebaseConfig = {
    apiKey: "AIzaSyBncXXEvO_DtqBK4Ese7JEeUoL3RF1y5kg",
    authDomain: "medific-authantication.firebaseapp.com",
    projectId: "medific-authantication",
    storageBucket: "medific-authantication.appspot.com",
    messagingSenderId: "110209983806",
    appId: "1:110209983806:web:ee1d69131fb29aee30f86f"
  };

export default firebaseConfig;